import * as actionTypes from '../actions/actionsTypes';

const initialState = {
  clubList: {
    data: []
  },
};

export const clubListReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CLUB_LIST:
      return {
        ...state,
        clubList: action.payload,
      };
    default:
      return state;
  }
};
